import { Pipe, PipeTransform } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'periodTranslate',
})
export class PeriodTranslatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: any, args?: any): any {
    if (value === 'unlimited') {
      return this.translateService.instant('common.period.unlimited');
    }

    const match = /(\d+)(y|m|w)/.exec(value);

    if (!match) {
      return value;
    }

    const number = match[1];
    let translateKey =
      'common.period.' + match[2] + (number !== '1' ? 's' : '');

    if (args && args.language) {
      translateKey = translateKey + '_' + args.language;
    }

    return this.translateService.instant(translateKey, { number });
  }
}
